import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  TextField,
  MenuItem,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { updateStatusToScheduleCall } from "../../api/callScheduleApi";
import { useNotification } from "../../hooks/useNotification";

const statusOptions = ["Completed", "Scheduled", "Pending", "Cancelled"];

export default function UpdateStatusModal({refetch, open, onClose }) {
  const scheduleCallSlice = useSelector(state=>state.schedulecall)
  const [newStatus, setNewStatus] = useState("Pending");
  const [comment, setComment] = useState("");
  const [saving,setSaving] = useState(false)
  const  { showSuccessNotification, showErrorNotification } = useNotification()

  const handleUpdate = () => {
        updateStatusToScheduleCall({setSaving,payload:{_id:scheduleCallSlice?.selectedScheduleCall?.id,status:newStatus?.toLowerCase(),comment},showSuccessNotification, showErrorNotification})
        .then(res=>{onClose();refetch()})
  };


  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: "16px" },
      }}
    >
      {/* Title with Close Button */}
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontWeight: 600, fontSize: "20px", color: "#15243E" }}>
          Update Request Status
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Content */}
      <DialogContent>
        {/* Student Details */}
        <Box mb={2}> 
          <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center',}}>
            <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", py: 0.5 }}>
            Student: <Typography variant="span" sx={{ fontWeight: "normal" }}>{scheduleCallSlice?.selectedScheduleCall?.studentDetails}</Typography>
          </Typography>
          <Typography variant="span" sx={{background:'#FFECA0',border:'1px solid #FFE187', color:'#FF6E20', fontSize:'12px', borderRadius:'20px', px:2,textTransform: 'capitalize' }}>{scheduleCallSlice?.selectedScheduleCall?.status}</Typography>
          </Box>
          <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", py: 0.5 }}>
            Course: <Typography variant="span" sx={{ fontWeight: "normal" }}>{scheduleCallSlice?.selectedScheduleCall?.universityName}</Typography>
          </Typography>
          <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", py: 0.5 }}>
            Request ID: <Typography variant="span" sx={{ fontWeight: "normal" }}>{scheduleCallSlice?.selectedScheduleCall?.requestID}</Typography>
          </Typography> 
        </Box>

        {/* New Status */}
        <Box mb={2}>
          <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", mb: 1 }}>
            New Status
          </Typography>
          <TextField
            select
            fullWidth
            value={newStatus}
            onChange={(e) => setNewStatus(e.target.value)}
            variant="outlined"
           sx={{
    "& .MuiInputBase-root": {
      height: 40,   fontSize:'14px', 
    },
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",  
      height: "100%",       
      padding: "0 14px",    
    },
  }}
          >
            {statusOptions.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </TextField>
        </Box>

        {/* Comment */}
        <Box mb={2}>
          <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", mb: 1 }}>
            Comment*
          </Typography>
          <TextField
            placeholder="Add comment about this status change..."
            fullWidth
            multiline
            minRows={3}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            variant="outlined"
             sx={{
    "& .MuiInputBase-root": {
        fontSize:'14px', 
    },
 "& .MuiInputBase-input::placeholder": {
        fontSize: "14px !important",        
        color: "#6E7485",       
      },
}}
          />
        </Box>
      </DialogContent>

      {/* Footer Actions */}
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={onClose} variant="outlined" sx={{ width: "100%", height: "50px" }}>
          Cancel
        </Button>
        <Button
          onClick={handleUpdate}
          variant="contained"
          loading={saving}
          disabled={!comment || !newStatus || saving}
          sx={{ background: "#1075FF", width: "100%", height: "50px", "&:hover": { background: "#0d63d6" } }}
        >
          Update Status
        </Button>
      </DialogActions>
    </Dialog>
  );
}
